import { useSelector } from 'react-redux';
import State from 'store/State';
import {
    BlotterComponentState,
    initialBlotterComponentState,
} from './BlotterComponentsState';
import { selectWidgetComponentState } from 'widgets/store/component/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectBlotterComponent = (state: State, widgetKey: string) => {
    return (
        selectWidgetComponentState<BlotterComponentState>(
            state,
            WidgetType.BLOTTER,
            widgetKey
        ) ?? initialBlotterComponentState
    );
};

export const useBlotterComponentSelector = (widgetKey: string) =>
    useSelector((state: State) => selectBlotterComponent(state, widgetKey));

export const useBlotterComponentSelectedRowIdsSelector = (
    widgetKey: string
) => {
    const blotterComponentState = useBlotterComponentSelector(widgetKey);
    return blotterComponentState.selectedRowIds;
};

export const selectBlotterSelectedRowIds = (
    widgetKey: string,
    state: State
) => {
    return selectBlotterComponent(state, widgetKey).selectedRowIds;
};
